import React, { Fragment } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import Banner from './banner';

const OfferDetail = ({ longOfferCard = false, withBuy = true, bannerHeight }) => {
  return (
    <div class="pse_sm">
    <div>
      <div>
        <div>
          {/* <div
            class="text-center sub_banner_comp banner-bg-assets pb-5"
            style={{ backgroundColor: '#ed1c24' }}
          >
            <img
            className='img-w250'
              src={
                process.env.PUBLIC_URL + '/assets/images/s-bundle.svg'
              }
            //   src={getImgSrc(data?.image, true)}
              alt=""
              title=""
            />
          </div> */}
          <Banner height={bannerHeight} />
        </div>
        <div class="white_detail_card -mt-24" style={{marginTop: '-38px'}}>
            {
                withBuy && (
                    <div className='shimmerBG shimmer-text-lg w-40'></div>
                )
            }
          <button
            class="btn_block shimmerBG shimmer-button-lg mb-0"
            style={{width: withBuy ? '120px' : ''}}
          >
          </button>
        </div>
        <h3 class="section_title mt-30 h3_title_restrct shimmerBG shimmer-text-md w-50"></h3>
        <div class="mt-20">
          <span class="primary_14 d-block shimmerBG shimmer-text-sm w-20"></span>
        </div>
        <div class="mt-2">
          <p className='formated-desc shimmerBG shimmer-p-text height-10'></p>
          <p className='formated-desc shimmerBG shimmer-p-text height-10'></p>
          <p className='formated-desc shimmerBG shimmer-p-text height-10'></p>
          <p className='formated-desc shimmerBG shimmer-p-text height-10'></p>
          <p className='formated-desc shimmerBG shimmer-p-text height-10'></p>
          <p className='formated-desc shimmerBG shimmer-p-text height-10 w-60'></p>
        </div>
      </div>  
    </div>

    <hr className="hr_line"></hr>
    <h3 className="section_title_light mb-4 mt-4 shimmerBG shimmer-text-md w-30"></h3>

    {
        !longOfferCard && (
            <Swiper className="auto_swiper_1" spaceBetween={12} slidesPerView="auto">
      {[1, 2, 3, 4]?.map((item, index) => {
        return (
          <Fragment key={index}>
            <SwiperSlide>
            <div className="card_style_3 height_100">
      <div className="card_img shimmerBG shimmer-img-md">
        {/* <img
          src={process.env.PUBLIC_URL + '/assets/images/device.png'}
          alt=""
          title=""
        /> */}
      </div>
      <div className="card_info text-center">
        <div className="card_info_grp">
          <h4 className='shimmerBG shimmer-text-xs w-80 mb-2 mx-auto'></h4>
          <p className='shimmerBG shimmer-p-text height-10 mb-1' style={{minHeight: '8px'}}></p>
          <p className='shimmerBG shimmer-p-text height-10 mb-1' style={{minHeight: '8px'}}></p>
        </div>
        <div className="card_link mt-3">
          {/* <div className="amount_stripe">23 KD /month</div> */}
          <a href="#" className="hyperlink shimmerBG shimmer-text-sm w-50">
            
            {/* <span className="text-lowercase"></span>
            <img
              src={
                process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
              }
              alt=""
              title=""
            /> */}
          </a>
        </div>
      </div>
    </div>
            </SwiperSlide>
          </Fragment>
        );
      })}
    </Swiper>
        )
    }

    { longOfferCard && 
        [1, 2, 3]?.map(item => {
            return (
            <div className="card_style_2 height_100 mb-3">
            <div className="card_img shimmerBG shimmer-img-xs" style={{width: '50px'}}>
                {/* <img src={process.env.PUBLIC_URL + '/assets/images/s-internet.svg'} alt="" title="" /> */}
            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    <h4 className='shimmerBG shimmer-text-sm w-40 mb-2'></h4>
                    <p className='shimmerBG shimmer-p-text height-10 mb-1'></p>
                    <p className='shimmerBG shimmer-p-text height-10 mb-1'></p>
                    <p className='shimmerBG shimmer-p-text height-10 w-70'></p>
                </div>
                <div className="card_link d-flex justify-content-end w-100">
                    <div className="hyperlink shimmerBG shimmer-text-xs w-20">
                        {/* <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" /> */}
                    </div>
                </div>
            </div>
        </div>
    )
        })
    }

    
    </div>
  )
}

export default OfferDetail